export default "__VITE_ASSET__C8UTJ9Lw__"